module.exports = __webpack_public_path__ + "static/media/slider33.5f277823.jpg";